import firebase from "firebase/app";
import 'firebase/firestore'
  
  const firebaseConfig = {
  apiKey: "AIzaSyAfwj5e-F0KYb_KRv3fi5QWoQm6JPVJERs",
  authDomain: "ckstocks-blog.firebaseapp.com",
  databaseURL: "https://ckstocks-blog-default-rtdb.firebaseio.com/",
  projectId: "ckstocks-blog",
  storageBucket: "ckstocks-blog.appspot.com",
  messagingSenderId: "155529458736",
  appId: "1:155529458736:web:094c939a63c2839d7129f5",
  measurementId: "G-Q0KR6PLZ4G"
}
  const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp;